import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_EV_DEMO_USE_CASE_4_EXP_VIDEO = {
  videoSrc: "EV/Use_case_4_exp.mp4",
  title: "CUSTOMER SERVICE: EXPLAINER VIDEO",
  onClose: () => setCurrentPage(414),
};

export default DATA_EV_DEMO_USE_CASE_4_EXP_VIDEO;
